import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { socials } from '../data/mock';

const PiercingSection = () => {
  const { t, lang } = useLang();
  const { content } = useContent();
  const piercings = content?.piercings || [];

  const openBooking = () => window.open(socials.instagram, '_blank', 'noopener,noreferrer');

  // Split list in two columns for desktop layout
  const half = Math.ceil(piercings.length / 2);
  const colA = piercings.slice(0, half);
  const colB = piercings.slice(half);

  const steelLabel = lang === 'fr' ? 'Acier chirurgical' : 'Surgical steel';
  const titaniumLabel = lang === 'fr' ? 'Titane' : 'Titanium';

  return (
    <section id="piercing" className="section-pad bg-[#FAF8F4] relative overflow-hidden">
      {/* Decorative arcs */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05]">
        <div className="absolute -top-40 -left-40 w-[700px] h-[700px] rounded-full border border-[#957340]" />
        <div className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full border border-[#957340]" />
        <div className="absolute -bottom-40 -right-40 w-[700px] h-[700px] rounded-full border border-[#957340]" />
        <div className="absolute -bottom-32 -right-32 w-[600px] h-[600px] rounded-full border border-[#957340]" />
      </div>

      <div className="container-tight relative">
        <div className="text-center mb-16">
          <span className="eyebrow">{t.piercing.eyebrow}</span>
          <h2 className="h-display mt-6" style={{ fontSize: 'clamp(56px, 9vw, 120px)' }}>
            Tarifs
          </h2>
          <p className="text-[14px] text-[#3A3A3A] leading-[1.7] mt-6 max-w-xl mx-auto">
            {t.piercing.subtitle}
          </p>
        </div>

        {/* Tarif table */}
        <div className="grid md:grid-cols-2 gap-x-16 lg:gap-x-24 gap-y-2 max-w-5xl mx-auto">
          <TariffColumn items={colA} lang={lang} steelLabel={steelLabel} titaniumLabel={titaniumLabel} />
          <TariffColumn items={colB} lang={lang} steelLabel={steelLabel} titaniumLabel={titaniumLabel} />
        </div>

        <div className="mt-16 text-center">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#8A8275] mb-6">
            {lang === 'fr'
              ? 'Tous nos bijoux sont stériles à usage unique'
              : 'All our jewelry is sterile and single-use'}
          </p>
          <button onClick={openBooking} className="btn-primary">
            {t.piercing.bookBtn}
          </button>
        </div>
      </div>
    </section>
  );
};

const TariffColumn = ({ items, lang, steelLabel, titaniumLabel }) => (
  <div>
    {/* Column header */}
    <div className="grid grid-cols-12 items-end gap-3 pb-4 mb-3 border-b border-[#1A1A1A]/40">
      <div className="col-span-5" />
      <div className="col-span-4 text-center">
        <div className="display text-[11px] tracking-[0.28em] uppercase text-[#1A1A1A]">{steelLabel}</div>
      </div>
      <div className="col-span-3 text-center">
        <div className="display text-[11px] tracking-[0.28em] uppercase text-[#1A1A1A]">{titaniumLabel}</div>
      </div>
    </div>

    {/* Rows */}
    <div className="space-y-[2px]">
      {items.map((p) => {
        const name = lang === 'fr' ? p.nameFr : p.nameEn;
        return (
          <div
            key={p.id}
            className="grid grid-cols-12 items-center gap-3 py-3 px-1 hover:bg-white/60 transition-colors duration-300 group"
          >
            <div className="col-span-5">
              <span className="serif text-[17px] md:text-[18px] text-[#1A1A1A] tracking-wide group-hover:text-[#957340] transition-colors">
                {name}
              </span>
            </div>
            <div className="col-span-4 text-center">
              <span className="display text-[15px] md:text-[16px] text-[#3A3A3A] tracking-wide">
                {p.priceSteel || '—'}
              </span>
            </div>
            <div className="col-span-3 text-center border-l border-[#1A1A1A]/20 py-1">
              <span className="display text-[15px] md:text-[16px] text-[#957340] tracking-wide">
                {p.priceTitanium || '—'}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default PiercingSection;
